export const types = {
  RENEW: 'renew',
  UPGRADE: 'upgrade',
};
